import { render, staticRenderFns } from "./StepStructure.vue?vue&type=template&id=1fa10099&scoped=true&"
import script from "./StepStructure.vue?vue&type=script&lang=ts&"
export * from "./StepStructure.vue?vue&type=script&lang=ts&"
import style0 from "./StepStructure.vue?vue&type=style&index=0&id=1fa10099&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa10099",
  null
  
)

export default component.exports